var React = require('react');

function Success (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7 12.4286L9.7 15L16 9","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M12 21C16.9705 21 21 16.9705 21 12C21 7.02943 16.9705 3 12 3C7.02943 3 3 7.02943 3 12C3 16.9705 7.02943 21 12 21Z","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Success.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","color":"currentColor"};

module.exports = Success;

Success.default = Success;
